// extracted by mini-css-extract-plugin
export default {"utilItem":"UtilItem_utilItem__kKlIl","name":"UtilItem_name__-t9gU"};